import React from 'react';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
import { CONTACT } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/5PB2T6CkyBda54JkDpJ8c2/Banner_Armando_Junk.png';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" className="relative isolate w-full overflow-hidden bg-forest-deep" data-id="element-119" data-mp="4n9zsnvorq5t">
      <img src={HERO_IMAGE} alt={t.hero.imageAlt} className="absolute inset-0 h-full w-full object-cover object-[70%_center]" data-id="element-120" data-mp="12860zz2gicrl" />
      <div className="absolute inset-0 bg-forest-deep/80 lg:bg-forest-deep/70" aria-hidden="true" data-id="element-121" data-mp="sb1a5lxo1t4g" />

      <div className="relative mx-auto max-w-7xl px-5 pb-20 pt-32 sm:pb-28 sm:pt-40 lg:px-8 lg:pb-36 lg:pt-48" data-id="element-122" data-mp="ncgkggg1iru9">
        <div className="max-w-2xl" data-id="element-123" data-mp="3d21v45faeyrf">
          <p className="mb-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-rust-light" data-id="element-124" data-mp="3d33fj0i70xlt">
            {t.hero.tag}
          </p>
          <h1 className="font-display text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-125" data-mp="3j7zcjaz8recz">
            {t.hero.headline}
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/85" data-id="element-126" data-mp="39acxmohxzmt0">
            {t.hero.subheadPre}
            <span className="font-semibold text-white" data-id="element-127" data-mp="3e95zfjnv9pdc">{t.hero.subheadStrong}</span>
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-128" data-mp="30iaziwvciilw">
            <a href={CONTACT.phoneHref} className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-md bg-rust px-7 py-4 font-display text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-rust-dark" data-id="element-129" data-mp="30g6kbirzxx6b">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-130" data-mp="2vgtx2wx7qo37" />
              {t.hero.callCta} {CONTACT.phone}
            </a>
            <a href="#contact" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border-2 border-white/70 px-7 py-4 font-display text-base font-bold text-white transition-colors duration-150 ease-out hover:border-white hover:bg-white hover:text-forest" data-id="element-131" data-mp="2lkilk95g629t">
              {t.hero.quoteCta}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-132" data-mp="ia5jeyju8jup" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}